var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-weight-bold font-italic red--text text--darken-3"},[_c('v-icon',{staticClass:"mr-1 pb-1",attrs:{"color":"red darken-2","small":""}},[_vm._v("fas fa-exclamation-triangle")]),_vm._v(" Do not record protected health information (PHI) in Continuum. ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }